import { Box } from "@mui/material";
import React from "react";
import { ReactComponent as CamAgentIcon } from "../../../assets/images/icons/CAM_user.svg";
import { ReactComponent as CqcAgentIcon } from "../../../assets/images/icons/CQC_agent.svg";
import { ReactComponent as CaiAgentIcon } from "../../../assets/images/icons/CAI_agent.svg";
import "../../../styles/pageStyles/chatbot/agentCards.css";

const AGENT_CARDS = [
  {
    title: "CAM Agent",
    desc: "Application Management",
    icon: <CamAgentIcon />,
  },
  {
    title: "CQC Agent",
    desc: "Manage duplicate applications",
    icon: <CqcAgentIcon />,
  },
  {
    title: "CAI Agent",
    desc: "Have a conversation about applications",
    icon: <CaiAgentIcon />,
  },
];

const AgentCards = ({ onCardClick }) => {
  return (
    <Box className="agent-cards-wrapper">
      {AGENT_CARDS.map((card) => (
        <Box
          key={card.title}
          component="a"
          className="agent-card"
          onClick={() => onCardClick?.(card.desc)}
        >
          <Box className="agent-card-header">
            {card.icon}
            <Box className="agent-card-title">{card.title}</Box>
          </Box>

          <Box className="agent-card-description">{card.desc}</Box>
        </Box>
      ))}
    </Box>
  );
};

export default AgentCards;